import { Component, inject } from '@angular/core';
import { FooterService } from '../services/footer.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [],
})
export class FooterComponent {
  footerService = inject(FooterService);

  isVisible = this.footerService.isVisible;
  currentYear = new Date().getFullYear();
}
